export const sortEdgesByOrder = (edges, fallbackCompare = null) => {
  const items = Array.isArray(edges) ? [...edges] : [];

  items.sort((a, b) => {
    const aOrder = a?.node?.frontmatter?.order;
    const bOrder = b?.node?.frontmatter?.order;
    const aHasOrder = Number.isFinite(aOrder);
    const bHasOrder = Number.isFinite(bOrder);

    if (aHasOrder && bHasOrder) {return aOrder - bOrder;}
    if (aHasOrder) {return -1;}
    if (bHasOrder) {return 1;}

    if (typeof fallbackCompare === 'function') {
      return fallbackCompare(a, b);
    }
    return 0;
  });

  return items;
};
